<template>
  <div class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto mb-4">
    <div class="overflow-hidden">
      <div class="p-4">
        <div class="flex items-start">
          <div class="flex-shrink-0">
            <component class="h-6 w-6 mt-1" :class="iconColor" :is="icon"/>
          </div>
          <div class="ml-3 w-0 flex-1 pt-0.5">
            <p v-show="title" class="text-sm leading-5 font-medium mb-1" :class="titleColor">
              {{ title }}
            </p>
            <slot></slot>
          </div>
          <div class="ml-4 flex-shrink-0 flex">
            <button @click="remove(id)"
                    class="inline-flex text-gray-400 focus:outline-none focus:text-gray-500 hover:text-gray-500 transition ease-in-out duration-150">
              <x-icon class="h-5 w-5"/>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex';


import {CheckCircleIcon, ExclamationIcon, XIcon, XCircleIcon, InformationCircleIcon} from '@heroicons/vue/solid'

export default {
  name: "SimpleNotify",
  components: {XIcon, XCircleIcon, InformationCircleIcon, ExclamationIcon, CheckCircleIcon},
  props: {
    type: {
      default: 'error',
      validator: function (value) {
        return ['success', 'warning', 'info', 'error'].indexOf(value) !== -1
      }
    },
    title: {
      default: ''
    },
    id: {
      required: true
    }
  },
  data() {
    return {
      types: {
        success: {icon: 'check-circle-icon', iconColor: 'text-green-500', titleColor: 'text-green-800'},
        error: {icon: 'x-circle-icon', iconColor: 'text-red-400', titleColor: 'text-red-800'},
        warning: {icon: 'exclamation-icon', iconColor: 'text-yellow-400', titleColor: 'text-yellow-800'},
        info: {icon: 'information-circle-icon', iconColor: 'text-blue-400', titleColor: 'text-blue-800'},
      },
    }
  },
  computed: {
    icon() {
      return this.types[this.type].icon;
    },
    iconColor() {
      return this.types[this.type].iconColor;
    },
    titleColor() {
      return this.types[this.type].titleColor;
    }
  },
  methods: {
    ...mapMutations('alerts', ['remove'])
  },
}
</script>
